import { ensureIsNonNullable } from './helpers';
import { IFatFeature, TFatFeatureModel } from '../types';

export const filterFatFeautreItems = (items: IFatFeature[]): TFatFeatureModel[] =>
  items.filter(ensureIsNonNullable) as TFatFeatureModel[];
